import EVENT_NAMES from './eventNames';

export default {
  ShowButton() {
    return new Event(EVENT_NAMES.SHOW_BUTTON);
  },

  HideButton() {
    return new Event(EVENT_NAMES.HIDE_BUTTON);
  },
};
